import React, { FC, PropsWithChildren, ReactNode } from 'react'
import classNames from 'classnames'
import { CaptionSM } from '@/atoms/Text'

type EventPillVariants = 'outline' | 'light' | 'dark'

const getVariantClassName = (variant: EventPillVariants) => {
  switch (variant) {
    case 'outline':
      return 'bg-transparent border border-core-gray-300 text-black'
    case 'dark':
      return 'bg-black/30 backdrop-blur-2xl text-white'
    case 'light':
      return 'bg-core-gray-200 text-black'
    default:
      return ''
  }
}

interface Props extends PropsWithChildren {
  variant: EventPillVariants
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  className?: string
  text: string
}

export const EventCardPill: FC<Props> = ({ variant, text, leftIcon, rightIcon, className }) => {
  return (
    <div
      className={classNames(
        'flex w-fit items-center gap-x-1 rounded-full px-3 py-1',
        getVariantClassName(variant),
        className,
      )}
    >
      {leftIcon && leftIcon}
      <CaptionSM>{text}</CaptionSM>
      {rightIcon && rightIcon}
    </div>
  )
}
